import React, { useState } from 'react';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { convertToRaw } from 'draft-js';
import MUIRichTextEditor from 'mui-rte';
import { PropTypes } from 'prop-types';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
// import { useEffect } from 'react';

const defaultTheme = createTheme();

const TextAlign = (props) => {
    return (
        <div
            style={{
                textAlign: props.alignment
            }}
        >
            {props.children}
        </div>
    );
};
TextAlign.propTypes = {
    alignment: PropTypes.string,
    children: PropTypes.any
};
const TextEditor = (props) => {
    Object.assign(defaultTheme, {
        overrides: {
            MUIRichTextEditor: {
                root: {
                    minHeight: !props.disableEditing ? '50vh' : '10vh'
                },
                toolbar: {
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    // flexWrap: 'wrap',
                    backgroundColor: props.isMobile ? '#e3e7ed' : '#d4e4fc',
                    borderRadius: props.isMobile ? '4px ' : '10px'
                },
                editorContainer: {
                    fontFamily: 'mainFont',
                    textAlign: 'start',
                    unicodeBidi: 'plaintext',
                    fontSize: props.disableEditing && '16px',
                    padding: props.disableEditing ? '0px' : '8px',
                    borderRadius: props.isMobile ? '4px ' : '9px',
                    height: !props.disableEditing ? '50vh' : '',
                    border: !props.disableEditing ? ' solid 1px #bbbbbb' : '',
                    // backgroundColor:  '#ffffff',
                    overflowY: 'auto',
                    '&::-webkit-scrollbar-track': {
                        background: '#e5e5e5',
                        border: '1px solid #e5e5e5',
                        boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0)'
                    }
                }
            },
            MuiIconButton: {
                root: {
                    marginLeft: props.isMobile ? '0px' : '13px',
                    '@media (max-width:350px)': {
                        '& svg': {
                            width: '.7em',
                            height: '.7em'
                        }
                    }
                }
            }
        }
    });
    const [value] = useState(props.defaultValue);
    const handleChange = (event) => {
        const rteContent = convertToRaw(event.getCurrentContent());
        props.handleChange(rteContent);
    };

    return (
        <MuiThemeProvider theme={defaultTheme}>
            <MUIRichTextEditor
                readOnly={props.disableEditing ? true : false}
                controls={props.controllers}
                customControls={[
                    {
                        name: 'text-center-align',
                        icon: <FormatAlignCenterIcon />,
                        type: 'block',
                        blockWrapper: <TextAlign alignment="center" />
                    },
                    {
                        name: 'text-left-align',
                        icon: <FormatAlignLeftIcon />,
                        type: 'block',
                        blockWrapper: <TextAlign alignment="left" />
                    },
                    {
                        name: 'text-right-align',
                        icon: <FormatAlignRightIcon />,
                        type: 'block',
                        blockWrapper: <TextAlign alignment="right" />
                    }
                ]}
                defaultValue={value}
                onChange={handleChange}
                inlineToolbar={props.inlineToolbarAvailable}
                label={props.label}
            />
        </MuiThemeProvider>
    );
};

TextEditor.propTypes = {
    controllers: PropTypes.any,
    defaultValue: PropTypes.string,
    inlineToolbarAvailable: PropTypes.bool,
    handleChange: PropTypes.func,
    label: PropTypes.string,
    disableEditing: PropTypes.bool,
    isMobile: PropTypes.bool
};

export default TextEditor;
